import axios from "axios";

const api = axios.create({
  //baseURL: "http://vps-5860948.rddelivery.com.br:8097",
  baseURL: "http://162.241.89.238:8097",
});

export default api;